import axiosAuth from '../../axiosMain';

async function store(question_id) {
  let response = await axiosAuth.post('/send_question_notification/' + question_id);
  return response.data;
}

export default {
  store,
};
